import { Text2xlLeading8FontSemiboldBlueGray800 } from '@flowwai-frontend/shared/style-guide'
import styled from 'styled-components'
import tw from 'twin.macro'

export const ButtonContainer = styled.div`
   display: flex;
   justify-content: center;
   margin-top: 15px;
`
export const Container = styled.div`
   ${tw`m-4`}
`

export const Content = styled.div`
   display: flex;
   justify-content: center;
`
export const FailureText = styled(Text2xlLeading8FontSemiboldBlueGray800)`
   font-size: 20px;
   text-align: center;
`
